import { EditIcon } from "@root/assets/icons/editIcon";
import DeleteIcon from "@root/assets/icons/delete-02.svg";
import { Flex, Image, Text } from "@chakra-ui/react";
import {
  COURSE_STATUS,
  DELETE,
  EDIT,
  getCourseStatus,
  requirementOptions,
} from "@root/constants";
import { useTranslation } from "react-i18next";
import { formatToShortDate } from "@root/utils/date-helper";

export const TableColumns = (handleActions: any) => {
  const { t } = useTranslation("common");
  return [
    {
      cell: (info: any) => info?.row?.original?.title || "",
      header: t("tableColumns.courseTitle"),
    },
    {
      cell: (info: any) => (
        <Text style={{ textWrap: "wrap" }}>
          {formatToShortDate(info?.row?.original?.createdAt) || ""}
        </Text>
      ),
      header: t("tableColumns.date"),
    },
    {
      cell: (info: any) => {
        const requirementItem = requirementOptions()?.find(
          (item: any) => Number(item.value) === info?.row?.original?.requirement
        );
        return (
          <Text
            as={"span"}
            sx={{
              textWrap: "wrap",
              fontWeight: 500,
              borderRadius: "24px",
              padding: "4px 10px",
              color:
                Number(requirementItem?.value) === 1 ? "#FE6807" : "#3A59D1",
              bgColor:
                Number(requirementItem?.value) === 1
                  ? "#FE68071A"
                  : "#3A59D11A",
            }}
          >
            {requirementItem?.label}
          </Text>
        );
      },
      header: t("tableColumns.requirement"),
    },
    {
      cell: (info: any) => info?.row?.original?.category?.title,
      header: t("tableColumns.category"),
    },
    {
      cell: (info: any) => {
        const status: 1 | 2 = info?.row?.original?.status;
        return (
          <Text
            as={"span"}
            sx={{
              textWrap: "wrap",
              fontWeight: 500,
              borderRadius: "24px",
              padding: "4px 10px",
              color: status === COURSE_STATUS.PUBLISHED ? "#00A177" : "#FBBF24",
              bgColor:
                status === COURSE_STATUS.PUBLISHED ? "#00A1771A" : "#FBBF241A",
            }}
          >
            {getCourseStatus()?.[status]}
          </Text>
        );
      },
      header: t("tableColumns.status"),
    },
    {
      cell: (info: any) => (
        <Flex gap={"14px"}>
          <Flex
            gap={"8px"}
            cursor={"pointer"}
            onClick={() => handleActions(EDIT, info?.row?.original)}
          >
            <EditIcon color={"#5C6670"} />
          </Flex>
          <Flex
            gap={"8px"}
            cursor={"pointer"}
            onClick={() => handleActions(DELETE, info?.row?.original)}
          >
            <Image src={DeleteIcon} width={18} />
          </Flex>
        </Flex>
      ),
      header: t("tableColumns.actions"),
    },
  ];
};
